import Vue from 'vue';
import VueRouter from 'vue-router';
import authGuard from './guards/authGuard';
import rolesGuard from './guards/rolesGuard';
import store from '@/store';
import login from './login';
import main from './main';
import manage from './manage';
import course from './course';
import TenantSessionService from '@/services/tenantSessionService';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: () => {
      if (store.getters['account/canViewManagePanel']) {
        return '/manage';
      } else if (store.getters['account/canViewHomePage']) {
        return '/home';
      } else {
        return '/login';
      }
    }
  },
  login(),
  // chooseModule, // TODO: replace with tenant choose page
  main([authGuard, rolesGuard('Student')]),
  manage([authGuard, rolesGuard(['CourseAdmin', 'Admin', 'Teacher'])]),
  course([authGuard, rolesGuard('Student')]),
  {
    path: '*',
    redirect: to => {
      const blacklist = router.options.routes.slice(1, -1).map(route => route.path);

      const tenant = to.fullPath.substr(0, to.fullPath.indexOf('/', 1) < 0 ? undefined : to.fullPath.indexOf('/'));
      if (tenant.toLowerCase() === '/host') {
        TenantSessionService.removeLastTenant();
        return '/login';
      } else if (tenant && !blacklist.includes(tenant)) {
        return { path: '/login', query: { t: tenant.substr(1) } };
      }

      return '/login';
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
